export const SET_MESSAGING_USER = 'SET_MESSAGING_USER';
export const SET_CALL_MESSAGES = 'SET_CALL_MESSAGES';
export const SET_CALLING_USER = 'SET_CALLING_USER';
export const SET_MESSAGES_IN_VIEW = 'SET_MESSAGES_IN_VIEW';
export const SET_CHATS = 'SET_CHATS';
export const SET_UNAUTHORIZED_MESSAGES = 'SET_UNAUTHORIZED_MESSAGES';
